import React, {Component, Fragment} from 'react';
import {Link} from 'react-router-dom';
import {observer, inject} from 'mobx-react';
import {withRouter} from 'react-router-dom';

import Where from './children/Where';
import Find from './children/Find';
import WhatsOn from './children/WhatsOn';

import Trails from './children/Trails';

import logo from '../../assets/images/valogo_yellow.svg';

import {TransitionGroup, CSSTransition} from 'react-transition-group';
import Location from "./children/Location";
import TrayContainerWithHeader from "../shared/TrayContainerWithHeader";

@inject('mapStore', 'routing')
@withRouter
@observer
class MapTools extends Component {
  getChildComponent() {
    const {url} = this.props.match;
    let child;

    const transitionedComponent = (component, transition_class) => (
      <TransitionGroup>
        <CSSTransition key={this.props.match.url} classNames={transition_class} timeout={300}>
          {component}
        </CSSTransition>
      </TransitionGroup>
    );

    switch (true) {
      case /^\/find\/whats-on$/.test(url):
        child = transitionedComponent(<WhatsOn/>, "show-map-tools");
        break;
      case /^\/find\/whats-on\/.+/.test(url):
        child = transitionedComponent(<WhatsOn/>, "show-map-tools");
        break;
      case /^\/find\/room$/.test(url):
        child = transitionedComponent(<Where title="Find a room"/>, "show-map-tools");
        break;
      case /^\/find\/room\/.+/.test(url):
        child = transitionedComponent(<Where title="Find a room"/>, "show-map-tools");
        break;
      case /^\/find/.test(url):
        child = transitionedComponent(<Find/>, "show-map-tools");
        break;
      case /^\/where-am-i$/.test(url):
        child = transitionedComponent(<Where title="Where am I?" whereAmI={true}/>, "show-map-tools");
        break;
      case /^\/where-am-i\/.+/.test(url):
        child = transitionedComponent(<Where title="You are here" whereAmI={true}/>, "show-map-tools");
        break;
      case /^\/trails/.test(url):
        child = transitionedComponent(<Trails/>, "show-map-tools");
        break;
      default:
        child = false;
        break;
    }

    if ((this.props.mapStore.highlightId !== null) && (this.props.mapStore.highlightId !== undefined)) {
      const location = this.props.mapStore.allFloorsData.find((item) => {return item.id === this.props.mapStore.highlightId})
      if (location) {
        const relatedResources = this.props.mapStore.relatedResources;
        return <TrayContainerWithHeader title="Showing" trayClass="room-detail"
                                        mapStore={this.props.mapStore} params={{path: url, ...this.props.match.params}}>
          <Location {...location} relatedResources={relatedResources} />
        </TrayContainerWithHeader>
      } else {
        return <React.Fragment></React.Fragment>
      }
    } else {
      return child;

    }
  }

  getTrayContainerClasses() {
    const {url} = this.props.match;
    let classes = '';
    switch (true) {
      case /^\/find$/.test(url):
        classes = 'is-find-icons';
        break;
      case /^\/where-am-i$/.test(url):
        classes = 'is-large';
        break;
      case /^\/find\/whats-on$/.test(url):
        classes = 'is-large';
        break;
      case /^\/find\/room$/.test(url):
        classes = 'is-large';
        break;
      case /^\/trails$/.test(url):
        classes = 'is-large';
        break;
      default:
        classes = ' ';
        break;
    }

    return ` ${classes} `;
  }

  render() {
    let child;
    let classes = `m-tray`;

    if ((this.props.mapStore.highlightId !== null) && (this.props.mapStore.highlightId !== undefined)) {
      classes += ' is-flexible showing-place';
      child = this.getChildComponent();
    } else if (this.props.mapStore.mapToolsOpen && !this.props.match.params.id) {
      classes += this.getTrayContainerClasses();
      child = this.getChildComponent();
    } else if (this.props.mapStore.mapToolsOpen && this.props.match.params.id) {
      classes += ` ${this.props.mapStore.trayContainerClass} ` ;
      child = this.getChildComponent();
    } else {
      classes += ' is-small';
      child = <ul className="m-main-menu">
        <li>
          <Link to='/find' className='find' data-tracking-mapnav="Find">
            <span>Find</span>
          </Link>
        </li>

        <li>
          <Link to='/where-am-i' className='where-am-i' data-tracking-mapnav="Where am I?">
            <span>Where Am I?</span>
          </Link>
        </li>
      {/*
        <li>
          <Link to='/trails' className='trails' data-tracking-mapnav="Trails">
            <span>Trails</span>
          </Link>
        </li>
        */}
      </ul>;
    }

    return (

      <Fragment>

        <div className={classes}>

          <div className="m-tray-logo-mobile">
            <Link to="/"><img src={logo} alt="V&A logo"/></Link>
          </div>


          {child}

        </div>

        <div className="m-tray-logo">
          <Link to="/"><img src={logo} alt="V&A logo"/></Link>
        </div>

      </Fragment>

    )
  }
}

export default MapTools;
